var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoContainer",staticClass:"dui-video"},[_c('div',{staticClass:"youtube-video",attrs:{"id":`youtube-video-${ _vm._uid }`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }